import { pipe } from 'rxjs';
import { getShipConfig } from '../../../config/ship/get-ship-config';
import { multiply, prop } from 'ramda';

export const getHullRepairCost = (hullToRepair: number) =>
  pipe(getShipConfig, prop('repairCosts'), multiply(hullToRepair));
